import { SiteLayoutComponent, SiteSection } from "shared/components/site-layout";
import { PageWithSettingsComponent } from 'shared/components/page-with-settings';
import { useParams } from "react-router-dom";
import { EtfPageParams as EtfPageRouteParams, EtfPageSection } from "../model";
import { EtfPageSettingsTitle } from '../shared/settings-title';
import { EtfPageSettingsContent } from "../shared/settings-content";
import { useEffect, useState } from "react";
import { EtfService, IEtfBackend, IEtfDocumentBackend } from "api/etf";
import { LoadingComponent } from "shared/components/loading";
import { EtfDocumentsPageContent } from "./components/content";
import { prerenderMarkLoaded } from "shared/mechanics/prerender";
import { usePageMeta } from "shared/mechanics/page-meta";

export const EtfDocumentsPage = () => {
	const params = useParams<EtfPageRouteParams>();
	const [etfInfo, setEtfInfo] = useState<IEtfBackend | null>(null);
	const [etfDocuments, setEtfDocument] = useState<IEtfDocumentBackend[] | null>(null);

	useEffect(
		() => { EtfService.info(params.ticker).then(etf => setEtfInfo(etf)); },
		[]);
	useEffect(
		() => { EtfService.documents(params.ticker).then(documents => setEtfDocument(documents)); },
		[]);

	usePageMeta({
		title: etfInfo == null 
			? 'Загрузка данных' 
			: `${etfInfo.ticker} - правила и отчетность`,
		description: etfInfo == null
			? ''
			: `Все документы фонда ${etfInfo.ticker}, включая правила, изменения в правилах, справки и изменения в СЧА, аудиторские заключения,`,
		keyWords: etfInfo == null
			? []
			: ['файлы', 'правила расчета СЧА', 'стоимость', 'справки', 'отчеты', etfInfo.ticker],
		canonicalPath: `etf/${params.ticker}/documents` });

	if (etfInfo == null || etfDocuments == null)
		return (
			<SiteLayoutComponent activeSection={SiteSection.None}>
				<LoadingComponent />
			</SiteLayoutComponent>
		)
	else {
		prerenderMarkLoaded();

		return (
			<SiteLayoutComponent activeSection={SiteSection.None}>
				<PageWithSettingsComponent
					defaultIsSettingsExpanded={true}
					settingsTitleChild={props => <EtfPageSettingsTitle {...props} ticker={etfInfo.ticker} shortDescription={etfInfo.shortDescription} />}
					settingsContentChild={<EtfPageSettingsContent section={EtfPageSection.DOCUMENTS} etf={etfInfo} />}
					settingCompactModeShowButtonText={etfInfo.ticker}
					contentChild={<EtfDocumentsPageContent ticker={etfInfo.ticker} documents={etfDocuments} />} />
			</SiteLayoutComponent>
		)
	}
};